import React from "react";
import { Link, IfPermitted } from "components/common";
import { Alert, Col, Row } from "components/bootstrap";
import LicensesRoutes from "license/Routes";
const Status = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", title: "Event Correlation is disabled" }, /* @__PURE__ */ React.createElement("p", null, "Event Correlation is disabled due to the absence of a valid license. It is still possible to update any existing Event Correlation, but new Alerts and Events will not be generated from them."), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: "licenses:create" }, /* @__PURE__ */ React.createElement("p", null, "See ", /* @__PURE__ */ React.createElement(Link, { to: LicensesRoutes.LIST }, "Licenses page"), " for details.")));
const EventsLicenseStatus = ({ licenseStatus: { status, missing }, summary = false }) => {
  if (!missing && status && status.valid) {
    return null;
  }
  if (summary) {
    return /* @__PURE__ */ React.createElement(Status, null);
  }
  return /* @__PURE__ */ React.createElement(Row, { className: "row-sm" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Status, null)));
};
export default EventsLicenseStatus;
